"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sign = void 0;
var Sign = function () { };
exports.Sign = Sign;
//# sourceMappingURL=Sign.js.map